import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {darkGray} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 0,
    paddingBottom: 20,
  },
  profileAttribute: {
    marginTop: 10,
    borderBottomColor: alto,
    borderBottomWidth: 1,
    paddingBottom: indent,
  },
  profileAttributeCertified: {
    marginTop: 10,
  },
  coach: {
    color: darkGray,
  },
});
